(function () {
  function initMotoSearch() {
    var sM = document.getElementById('sel-marca');
    var sMo = document.getElementById('sel-modello');
    var sA = document.getElementById('sel-anno');
    var btn = document.getElementById('moto-btn');

    if (!sM || !sMo || !sA || !btn) return;
    if (sM.dataset.motoInitialized === 'true') return;
    sM.dataset.motoInitialized = 'true';

    sM.disabled = true;
    sMo.disabled = true;
    sA.disabled = true;
    btn.disabled = true;

    function resetSelect(select, label) {
      select.innerHTML = '';
      select.add(new Option(label, ''));
    }

    resetSelect(sM, '-- Caricamento marche... --');
    resetSelect(sMo, '-- Modello --');
    resetSelect(sA, '-- Anno --');

    var errorMessage = document.getElementById('moto-search-error');

    if (!errorMessage) {
      errorMessage = document.createElement('p');
      errorMessage.id = 'moto-search-error';
      errorMessage.setAttribute('role', 'alert');
      errorMessage.style.color = '#fff';
      errorMessage.hidden = true;
      btn.parentNode.appendChild(errorMessage);
    }

    function uniqueSorted(values) {
      return Array.from(new Set(values)).sort(function (a, b) {
        return a.localeCompare(b, 'it', { numeric: true });
      });
    }

    function addOptions(select, values) {
      values.forEach(function (value) {
        select.add(new Option(value, value));
      });
    }

    function slug(value) {
      return String(value)
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-');
    }

    function fetchPage(url, accumulated, visited) {
      var pageUrl = new URL(url, window.location.origin);

      if (pageUrl.origin !== window.location.origin) {
        return Promise.reject(new Error('Indirizzo dati non valido.'));
      }

      if (visited.has(pageUrl.href)) {
        return Promise.reject(new Error('Paginazione dati ripetuta.'));
      }

      visited.add(pageUrl.href);

      return fetch(pageUrl.href, {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Caricamento dati: HTTP ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var main = doc.querySelector('#MainContent');

          if (!main) {
            throw new Error(
              'Contenuto dati non trovato in /pages/moto-data.'
            );
          }

          var content = main.cloneNode(true);

          content.querySelectorAll(
            '.pagination-wrapper, .pagination, nav, script, style'
          ).forEach(function (element) {
            element.remove();
          });

          var data;

          try {
            data = JSON.parse(content.textContent.trim());
          } catch (error) {
            throw new Error(
              '/pages/moto-data non restituisce un elenco JSON valido.'
            );
          }

          if (!Array.isArray(data)) {
            throw new Error('Formato dati compatibilità non valido.');
          }

          var combined = accumulated.concat(data);
          var next = doc.querySelector('a[rel="next"]');

          if (next) {
            var nextUrl = new URL(
              next.getAttribute('href'),
              pageUrl.href
            );

            return fetchPage(nextUrl.href, combined, visited);
          }

          return combined;
        });
    }

    sM.onchange = function () {
      resetSelect(sMo, '-- Modello --');
      resetSelect(sA, '-- Anno --');

      sMo.disabled = true;
      sA.disabled = true;
      btn.disabled = true;

      if (!sM.value) return;

      var models = uniqueSorted(
        window.motoData
          .filter(function (row) {
            return row[0] === sM.value;
          })
          .map(function (row) {
            return row[1];
          })
      );

      addOptions(sMo, models);
      sMo.disabled = models.length === 0;
    };

    sMo.onchange = function () {
      resetSelect(sA, '-- Anno --');

      sA.disabled = true;
      btn.disabled = true;

      if (!sMo.value) return;

      var years = uniqueSorted(
        window.motoData
          .filter(function (row) {
            return row[0] === sM.value && row[1] === sMo.value;
          })
          .map(function (row) {
            return row[2];
          })
      ).reverse();

      addOptions(sA, years);
      sA.disabled = years.length === 0;
    };

    sA.onchange = function () {
      btn.disabled = !(sM.value && sMo.value && sA.value);
    };

    btn.onclick = function (event) {
      event.preventDefault();

      if (!sM.value || !sMo.value || !sA.value) {
        alert('Seleziona marca, modello e anno');
        return;
      }

      window.location.href =
        '/collections/all/compat-' +
        slug(sM.value) + '-' +
        slug(sMo.value) + '-' +
        slug(sA.value);
    };

    fetchPage('/pages/moto-data', [], new Set())
      .then(function (rows) {
        var data = rows
          .filter(function (row) {
            return Array.isArray(row) &&
              row.length >= 3 &&
              row.slice(0, 3).every(function (value) {
                return value !== null &&
                  value !== undefined &&
                  String(value).trim() !== '';
              });
          })
          .map(function (row) {
            return row.slice(0, 3).map(function (value) {
              return String(value).trim();
            });
          });

        if (!data.length) {
          throw new Error('Nessuna compatibilità valida ricevuta.');
        }

        window.motoData = data;

        var brands = uniqueSorted(
          data.map(function (row) {
            return row[0];
          })
        );

        resetSelect(sM, '-- Marca --');
        addOptions(sM, brands);

        sM.disabled = false;
        errorMessage.hidden = true;
      })
      .catch(function (error) {
        console.error('Cerca per moto:', error);

        resetSelect(sM, '-- Caricamento non riuscito --');

        errorMessage.textContent =
          'Non è stato possibile caricare le compatibilità. ' +
          'Ricarica la pagina per riprovare.';

        errorMessage.hidden = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotoSearch);
  } else {
    initMotoSearch();
  }

  document.addEventListener('shopify:section:load', initMotoSearch);
})();
